import React, { Component } from 'react';
import { Link } from "react-router-dom";
import logo from './logo_dark.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
          <h2>Politica de Privacidade</h2>
        </div>
        <nav>
        <Link to="/privacy-policies">Privacy Policies</Link> |{" "}
        <Link to="/terms-of-service">Terms of Service</Link>
      </nav>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js